import { Flex, TabNav, Text } from '@radix-ui/themes';
import PropTypes from 'prop-types';
import React from 'react';
import { NavLink } from 'react-router-dom';
import Icon from '~/components/Icon';

const PAGES = [
  { label: 'Home', to: '/dashboard', iconName: 'home', activeIconName: 'home-solid', isOrgGodRestricted: true },
  {
    label: 'SIMs',
    to: '/sims',
    iconName: 'simcard',
    activeIconName: 'sim-card-solid',
    dataIntercomTarget: 'nav_menu_item_sims',
  },
  {
    label: 'Usage',
    to: '/usage',
    iconName: 'bar-chart-10',
    activeIconName: 'bar-chart-10-solid',
    isOrgGodRestricted: true,
  },
  { label: 'Network lists', to: '/network-lists', iconName: 'list', isOrgGodRestricted: true },
  { label: 'Users', to: '/users', iconName: 'user', activeIconName: 'user-03-solid', isOrgMemberRestricted: true },
  { label: 'Tags', to: '/tags', iconName: 'tag-02', activeIconName: 'tag-02-solid', isOrgMemberRestricted: true },
  {
    label: 'Error log',
    to: '/error-log',
    iconName: 'brackets-x',
    isOrgMemberRestricted: true,
    isOrgGodRestricted: true,
  },
  {
    label: 'Webhooks',
    to: '/webhooks',
    iconName: 'webhooks',
    isOrgMemberRestricted: true,
    isOrgGodRestricted: true,
    featureName: 'management.webhooks',
  },
  {
    label: 'API keys',
    to: '/api-keys',
    iconName: 'key-01',
    activeIconName: 'key-01-solid',
    featureName: 'management.apiKeys',
    isOrgGodRestricted: true,
  },
  {
    label: 'Connectors',
    to: '/connectors',
    iconName: 'link-02',
    featureName: 'connectors',
    isOrgGodRestricted: true,
  },
  {
    label: 'Audit log',
    to: '/audit-logs',
    iconName: 'fingerprint-04',
    featureName: 'management.auditLogs',
    isForOwnerGodOnly: true,
  },
];

function Menu({ location, userInfo: { isOrgMember, isOwner, isGod, isOrgGod } }) {
  return (
    <TabNav.Root
      color='gray'
      justify='start'
    >
      <Flex
        width='100%'
        justify='center'
      >
        {PAGES.map(item => {
          const isActive = location.pathname.includes(item.to);
          if (item.isOrgMemberRestricted && isOrgMember) return null;
          if (item.isForOwnerGodOnly && !(isOwner || isGod)) return null;
          if (item.isOrgGodRestricted && isOrgGod) return null;
          return (
            <TabNav.Link
              asChild
              key={item.label}
              active={isActive}
              data-intercom-target={item.dataIntercomTarget}
            >
              <NavLink to={item.to}>
                <Flex
                  gap='2'
                  align='center'
                >
                  <Icon
                    name={(isActive && item.activeIconName) || item.iconName}
                    width={16}
                    height={16}
                    color='currentColor'
                  />
                  <Text
                    size='2'
                    weight='bold'
                    color={isActive ? 'var(--gray-a11)' : 'var(--gray-12)'}
                  >
                    {item.label}
                  </Text>
                </Flex>
              </NavLink>
            </TabNav.Link>
          );
        })}
      </Flex>
    </TabNav.Root>
  );
}

Menu.propTypes = {
  location: PropTypes.obj,
  userInfo: {
    isOrgMember: PropTypes.bool,
    isOwner: PropTypes.bool,
    isGod: PropTypes.bool,
    isOrgGod: PropTypes.bool,
  },
};

export default Menu;
